<template>
  <div class="shortcast-description">
    <b-headline type="h3" typography="h4" class="shortcast-description__header mb-4">
      {{ $t("whatIsItAbout", { shortcastTitle: shortcastTitle }) }}
    </b-headline>
    <div class="shortcast-description__text" v-html="shortcastDescription" />
  </div>
</template>

<script>
import BHeadline from "@/component-library/b-headline"

export default {
  name: "ShortcastDescription",
  components: {
    BHeadline
  },
  props: {
    shortcastTitle: {
      type: String,
      required: true
    },
    shortcastDescription: {
      type: String,
      required: true
    }
  },
  i18n: {
    messages: {
      en: {
        whatIsItAbout: "What is {shortcastTitle} about?"
      },
      de: {
        whatIsItAbout: "Worum geht’s bei {shortcastTitle}?"
      }
    }
  }
}
</script>

<style lang="scss">
.shortcast-description {
  &__text {
    @include font-style(p1);

    p {
      /* The tagline is saved in markdown so we need to prevent the p tag to create extra 16 px spacing */
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
}
</style>
